import {
  tabBorderClasses,
  tabClasses,
  tabTitleContainerClasses,
} from './styles'

export const Tab = ({
  title,
  link,
  ix,
  activeTab,
  onClick,
  titleSuffix = null,
  className = '',
  activeClassName = '',
}) => {
  const isActive = activeTab === ix
  const defaultActiveClass = 'text-secondary'
  const defaultActiveBorderClass = 'bg-secondary'
  const textClass = className || (isActive ? defaultActiveClass : '')
  const borderClass = activeClassName || (isActive ? defaultActiveBorderClass : '')

  return (
    <div
      className={`${tabClasses} ${textClass}`}
      onClick={() => onClick({ link, ix })}
    >
      <div className={tabTitleContainerClasses}>
        <span>{title}</span>
        {titleSuffix}
      </div>
      <div
        className={`${tabBorderClasses} ${isActive ? borderClass : ''}`}
      ></div>
    </div>
  )
}
